import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceColumnsVisibilitySettingsWrapper = styled.div`
  width: 100%;
  padding: ${Spacing.S12} ${Spacing.S8};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  ${getShadow('raisedStrong')}
`
